import React from 'react'
import Yup from '../../../../../helpers/custom-yup'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import PeriodFields from '../../../../../components/form-components/period-inputs.component'
import ClientTicketModal from './../../../client/my-purchases/components/client-ticket-modal-container.component'
import ModalConfirmation from './../../../../../components/modal/modal-confirmation.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { StyledForm } from './styles.style'
import { maskHelper } from '../../../../../helpers/mask.helper'
import { SaleService } from './../../../../../services/sale.service'
import { SelectInput } from '../../../../../components/form-components/inputs.component'
import { AdminService } from '../../../../../services/admin.service'
import { PaginationFooter } from './components/pagination-footer.component'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { salesRevenueActions } from './sales-revenue.actions'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'
import {
	NumberInput,
	AsyncSelectInput
} from '../../../../../components/form-components/inputs.component'
import { PAYMENT_METHODS } from '../../../../../constants/payment-method.constants'
import styled from 'styled-components'
import { dateHelper } from '../../../../../helpers/date.helper'


const StyledSpan = styled.span`
	&:hover{
		.fa{
			transition: all 0.5s;
			color:#666 !important;
		}
	}
`

const validationSchema = Yup.object().shape({
	dateFilterType: Yup.string().required('Informe tipo de data'),
	period: Yup.string().required('Escolha um período')
})
const paymentOption = { value: 'payment', label: 'Pagamento' }
const saleOption = { value: 'sale', label: 'Venda' }
const dueOption = { value: 'due', label: 'Vencimento' }

const dateFilterTypeOptions = [saleOption, paymentOption, dueOption]

const sortable = {
	defaultOrder: 'desc',
	cols: [
		{ key: 'orderNumber' },
		{ key: 'saleDate' },
		{ key: 'payDay' },
		{ key: 'clientName' },
		{ key: 'productName' },
		{ key: 'paymentMethod' },
		{ key: 'status' },
		{ key: 'value' },
		{ key: 'interest' },
		{ key: 'points' }
	]
}

const headers = [
	{ header: 'Data venda', key: 'saleDate', align: 'center' },
	{ header: 'Data pagamento', key: 'payDay', align: 'center' },
	{ header: 'Cliente', key: 'clientName' },
	{ header: 'CPF', key: 'clientCpf' },
	{ header: 'Produto', key: 'productName' },
	{ header: 'Meio pagamento', key: 'paymentMethod' },
	{ header: 'Situação', key: 'status' },
	{ header: 'Documento', key: 'document' },
	{ header: 'Pedido', key: 'orderNumber' },
	{ header: 'Valor total', key: 'value', align: 'center' },
	{ header: 'Juros', key: 'interest', align: 'center' },
	{ header: 'Pontos', key: 'points', align: 'center' },
	{ header: ' ', key: 'actions', align: 'center' }
]

const defaultOption = {
	value: '',
	label: 'Todas'
}

class SalesRevenueReportPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			productOptions: [{ value: '', label: 'Todos' }],
			initialValues: {
				period: 30,
				productId: '',
				ourNumber: '',
				orderNumber: '',
				paymentMethod: '',
				paymentStatus: '',
				moveflexNumber: '',
				isModalOpen: false,
				finalDate: moment(),
				dateFilterType: saleOption.value,
				initialDate: moment().subtract(30, 'days')
			},
			isExporting: false,
			sumPoints: 0,
			sumValue: 0
		}

		this.footerComponent = () => {
			const { sumValue, sumPoints } = this.state
			return <PaginationFooter sumValue={sumValue} sumPoints={sumPoints} />
		}

		this.loadOptions = (inputValue, callback) => {
			if (this.previousInputValue === inputValue) return
			this.previousInputValue = inputValue
			AdminService.searchUsersToMovePoints(inputValue).then(({ data }) => {
				callback(
					data.length ? [].concat(defaultOption, mapOptions(data)) : null
				)
			})
		}

		const functions = {
			onChangeDateFilterType: this.onChangeDateFilterType,
			initialDateIsOutSideRange: this.initialDateIsOutSideRange,
			finalDateIsOutSideRange: this.finalDateIsOutSideRange,
			loadOptions: this.loadOptions,
			handleExport: this.handleExport
		}
		this.renderFormik = props =>
			renderFormik(props, this.state.productOptions, functions)

		this.onResult = onResult.bind(this)
		this.renderRow = renderRow.bind(this)
		this.cancelSale = cancelSale.bind(this)

		this.value = 0
		this.orderNumber = 0
	}

	componentWillMount() {
		AdminService.getProductOptions().then(({ data: productOptions }) =>
			this.setState({
				productOptions: [{ value: '', label: 'Todos' }, ...productOptions]
			})
		)
	}

	componentDidMount() {
		setTimeout(() => {
			this.refs.form && this.refs.form.submitForm()
		}, 0)
	}

	render() {
		const { user } = this.props
		const { initialValues, isModalOpen } = this.state
		const {
			productId,
			finalDate,
			ourNumber,
			initialDate,
			orderNumber,
			paymentMethod,
			paymentStatus,
			dateFilterType = saleOption.value,
			moveflexNumber
		} = initialValues

		return (
			<InnerPageContainer>
				<Title>Relatório de vendas/faturamento</Title>
				<h3 className="orange semi-bold">Filtros</h3>
				<Formik
					ref="form"
					initialValues={initialValues}
					validationSchema={validationSchema}
					onSubmit={this.onSubmit}
					render={this.renderFormik}
				/>
				<div data-permission="BBEDA996DDF867EB6A3D2E46557B75383C61C91A">
					<PaginationComponent
						ref="pagination"
						rowsPerPage={100}
						getData={AdminReportsService.getSalesAndRevenueReport}
						params={{
							dateFilterType,
							dateStart: dateHelper.formatToYYYYMMDD(initialDate),
							dateEnd: dateHelper.formatToYYYYMMDD(finalDate),
							productId,
							moveflexNumber,
							paymentMethod,
							paymentStatus,
							ourNumber,
							orderNumber
						}}
						headers={headers}
						footerComponent={this.footerComponent}
						sortable={sortable}
						renderRow={this.renderRow}
						user={user}
					/>
				</div>
				<ModalConfirmation
					sourceCall="employee-sales-revenue"
					isOpen={isModalOpen}
					onResult={this.onResult}
					title={`Cancelamento - Pedido ${this.orderNumber}`}>
					Confirmar o cancelamento da compra no valor de{' '}
					{(+this.value).$toReais()}?
				</ModalConfirmation>
				<ClientTicketModal sourceCall="employee-sales-revenue" />
			</InnerPageContainer>
		)
	}

	handleExport = () => {
		this.setState({ isExporting: true }, () => {
			this.refs.form.submitForm()
		})
	}

	onSubmit = values => {
		const { isExporting } = this.state

		const normalizedValues = {
			dateFilterType: values.dateFilterType,
			dateStart: dateHelper.formatToYYYYMMDD(values.initialDate),
			dateEnd: dateHelper.formatToYYYYMMDD(values.finalDate),
			period: values.period,
			productId: values.productId,
			moveflexNumber: values.moveflexNumber,
			paymentMethod: values.paymentMethod,
			paymentStatus: values.paymentStatus,
			ourNumber: values.ourNumber,
			orderNumber: values.orderNumber
		}

		isExporting
			? this.exportData(normalizedValues)
			: this.showResultTable(normalizedValues)
	}

	exportData = values => {
		const { exportData } = this.props

		exportData(values)
		this.setState({ isExporting: false })
	}

	showResultTable = values => {
		AdminReportsService.getTotalPointsAndTotalValue(values).then(
			({ data }) => {
				this.setState({
					initialValues: {
						dateFilterType: values.dateFilterType,
						period: values.period,
						moveflexNumber: values.moveflexNumber,
						initialDate: moment(values.dateStart, 'YYYY-MM-DD'),
						finalDate: moment(values.dateEnd, 'YYYY-MM-DD'),
						productId: values.productId,
						paymentMethod: values.paymentMethod,
						paymentStatus: values.paymentStatus,
						ourNumber: values.ourNumber,
						orderNumber: values.orderNumber
					},
					sumValue: data.totalValue,
					sumPoints: data.totalPoints
				})
				this.refs.pagination.reload()
			}
		)
	}

	onChangeDateFilterType = ({ value: dateFilterType }) =>
		this.setState({
			initialValues: { ...this.state.initialValues, dateFilterType }
		})

	initialDateIsOutSideRange = (value, finalDate) => {
		const { dateFilterType } = this.state.initialValues

		const isAfterFinalDateOrBeforeTwoYears =
			value.isAfter(moment(finalDate, 'DD/MM/YYYY')) ||
			value.isBefore(moment(finalDate, 'DD/MM/YYYY').subtract(24, 'months'))

		return dateFilterType === paymentOption.value
			? isAfterFinalDateOrBeforeTwoYears ||
			value.isSameOrAfter(
				moment()
					.add(1, 'd')
					.subtract(1, 'ms')
			)
			: isAfterFinalDateOrBeforeTwoYears
	}

	finalDateIsOutSideRange = (value, initialDate) => {
		const { dateFilterType } = this.state

		const isBeforeInitialDateOrAfter24MonthsFromInitialDate =
			value.isBefore(moment(initialDate, 'DD/MM/YYYY')) ||
			value.isAfter(moment(initialDate, 'DD/MM/YYYY').add(24, 'months'))

		return dateFilterType === 'purchase'
			? isBeforeInitialDateOrAfter24MonthsFromInitialDate ||
			value.isSameOrAfter(
				moment()
					.add(1, 'd')
					.subtract(1, 'ms')
			)
			: isBeforeInitialDateOrAfter24MonthsFromInitialDate
	}
}

function onResult(result) {
	this.setState({ isModalOpen: false })
	if (result) {
		this.cancelSale()
	}
}

function cancelSale() {
	this.props.showLoading()
	SaleService.cancelSale({ orderNumber: this.orderNumber }).then(
		({ success }) => {
			this.props.hideLoading()
			if (success) {
				this.refs.pagination.reload()
			}
		}
	)
}

function renderRow(rowData, headers) {
	const showTicketModal = rowData.productName == 'Compra de passagem'
	const onClickRow = showTicketModal
		? () => {
			this.props
				.getPurchaseTickets(rowData.orderNumber)
				.then(this.props.openClientTicketModal)
		}
		: null

	const onClickQrCode = () => { this.props.openQrCodeModal({ pixImageQrCode: rowData.pixImageQrCode, pixEmv: rowData.pixEmv, pixValidity: rowData.pixValidity }) }

	return headers.map(({ key, align }) => {
		const isKeyActions = key === 'actions'

		if (isKeyActions) {
			const {
				value,
				status,
				orderNumber,
				productName,
				paymentMethod,
				pixImageQrCode
			} = rowData


			const paid = status == 'Pago'
			const withCreditCard = paymentMethod == 'Cartão de crédito'
			const paidWithCreditCard = paid && withCreditCard

			const canCancelPointsPurchase =
				paidWithCreditCard && productName == 'Compra de pontos'

			const showQrCode = !(pixImageQrCode == null || paid || paymentMethod.toUpperCase() !== PAYMENT_METHODS.PIX.toUpperCase())

			const CancelPointsPurchaseAction = canCancelPointsPurchase ? (
				<StyledSpan
					data-permission="27B788E5B76F936E4A6A414822FA1DF225057FC9"
					title="Cancelar compra"
					onClick={() => {
						this.value = value
						this.orderNumber = orderNumber
						this.setState({ isModalOpen: true })
					}}>
					<FontAwesome name="ban" />
				</StyledSpan>

			) : null
			const QrCodeAction = showQrCode ? (
				<StyledSpan
					title="Exibir QRCode para pagamento"
					onClick={onClickQrCode}>
					<FontAwesome name="qrcode" />
				</StyledSpan>
			) : null

			const OpenTicketModalAction = showTicketModal ? (
				<StyledSpan
					title="visualizar detalhes da viagem"
					style={{ marginLeft: '1em' }}
					onClick={onClickRow}>
					<FontAwesome name="ticket" />
				</StyledSpan>
			) : null

			return (
				<td key={key}>
					{QrCodeAction}
					{OpenTicketModalAction}
					{CancelPointsPurchaseAction}
				</td>
			)
		}

		if (key == 'clientCpf') rowData[key] = maskHelper.applyCpf(rowData[key])
		return (
			<td
				key={key}
				align={align}
				onClick={onClickRow}
				style={key == 'status' ? shouldBeRed(rowData) : {}}>
				<span title={rowData[key]}>{handleRowData(rowData[key], key)}</span>
			</td>
		)
	})
}

function renderFormik(
	props,
	productOptions,
	{
		onChangeDateFilterType,
		initialDateIsOutSideRange,
		finalDateIsOutSideRange,
		loadOptions,
		handleExport
	}
) {
	return (
		<StyledForm noValidate onSubmit={props.handleSubmit}>
			<SelectInput
				id="dateFilterType"
				label="Filtrar por data de"
				onValueChange={onChangeDateFilterType}
				options={dateFilterTypeOptions}
				{...props}
			/>
			<PeriodFields
				initialDateIsOutSideRange={initialDateIsOutSideRange}
				finalDateIsOutSideRange={finalDateIsOutSideRange}
				{...props}
			/>
			<SelectInput
				id="productId"
				label="Produto"
				options={productOptions}
				{...props}
			/>
			<AsyncSelectInput
				id="moveflexNumber"
				label="Conta"
				loadOptions={loadOptions}
				{...props}
			/>
			<SelectInput
				id="paymentMethod"
				label="Meio de pagamento"
				options={[
					{ value: '', label: 'Todos' },
					{ value: 'creditCard', label: 'Cartão de crédito' },
					{ value: 'muvicard', label: 'Cartão Muvicard' },
					{ value: 'pix', label: 'Pix' },
					{ value: 'onlineDebit', label: 'Débito on-line' },
					{ value: 'bankSlip', label: 'Boleto bancário' },
					{ value: 'pointRedemption', label: 'Resgate' }
				]}
				{...props}
			/>
			<SelectInput
				id="paymentStatus"
				label="Situação do pagamento"
				options={[
					{ value: '', label: 'Todas' },
					{ value: 'processing', label: 'Em processamento' },
					{ value: 'paid', label: 'Pago' },
					{ value: 'canceled', label: 'Cancelado' }
				]}
				{...props}
			/>
			<NumberInput id="ourNumber" label="Número do documento" {...props} />
			<NumberInput id="orderNumber" label="Número do pedido" {...props} />
			<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<Button
					secondary
					type="button"
					onClick={handleExport}
					style={{ marginRight: '15px' }}
					data-permission="CCFE430284191EB369F7F0DE6C27B5E4FE5604BF">
					Exportar
				</Button>
				<Button
					data-permission="BBEDA996DDF867EB6A3D2E46557B75383C61C91A"
					primary
					type="submit">
					Consultar
				</Button>
			</div>
		</StyledForm>
	)
}

function mapOptions(options) {
	return options.map(({ moveflexNumber, data }) => ({
		value: moveflexNumber,
		label: data
	}))
}

const shouldBeRed = rowData => {
	switch (rowData.status) {
		case 'Pendente':
		case 'Cancelado':
		case 'Em processamento':
			return { color: 'red' }
		default:
			return {}
	}
}

const handleRowData = (rowData, key) => {
	switch (key) {
		case 'value':
			return Number(rowData.replace(',', '.')).$toReais()

		case 'interest':
			return Number(rowData.replace(',', '.')).$toReais()

		case 'points':
			return Number(rowData).toLocaleString('pt-BR')

		default:
			return rowData
	}
}

const mapStateToPros = ({ adminSalesRevenueExtractReport, user }) => ({
	...adminSalesRevenueExtractReport,
	user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...salesRevenueActions,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
			openClientTicketModal: ClientTicketModalCreators.openModal,
			openQrCodeModal: ClientTicketModalCreators.openQrCodeModal,
			getPurchaseTickets: ClientTicketModalCreators.fetchDataAsAdmin
		},
		dispatch
	)

const ConnectedSalesRevenueReportPage = connect(
	mapStateToPros,
	mapDispatchToProps
)(SalesRevenueReportPage)

export { ConnectedSalesRevenueReportPage as ModuleRootComponent }
